import React from 'react';
import { useEmailStats } from '@/hooks/useEmailLogs';
import { Mail, CheckCircle, XCircle, Clock, Calendar } from 'lucide-react';

const EmailStatsCards = () => {
  const { data: stats, isLoading } = useEmailStats();

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="bg-white/5 border border-white/10 rounded-xl p-4 animate-pulse">
            <div className="h-8 bg-white/10 rounded mb-2" />
            <div className="h-4 bg-white/10 rounded w-2/3" />
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      label: 'Enviados Hoje',
      value: stats?.today_sent || 0,
      icon: Calendar,
      color: 'text-green-400',
      bg: 'bg-green-500/10',
    },
    {
      label: 'Total Enviados',
      value: stats?.total_sent || 0,
      icon: CheckCircle,
      color: 'text-blue-400',
      bg: 'bg-blue-500/10',
    },
    {
      label: 'Pendentes',
      value: stats?.total_pending || 0,
      icon: Clock,
      color: 'text-yellow-400',
      bg: 'bg-yellow-500/10',
    },
    {
      label: 'Falharam',
      value: stats?.total_failed || 0,
      icon: XCircle,
      color: 'text-red-400',
      bg: 'bg-red-500/10',
    },
    {
      label: 'Agendados',
      value: stats?.scheduled_pending || 0,
      icon: Mail,
      color: 'text-purple-400',
      bg: 'bg-purple-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {cards.map((card) => (
        <div 
          key={card.label} 
          className="bg-white/5 border border-white/10 rounded-xl p-4"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className={`p-2 rounded-lg ${card.bg}`}>
              <card.icon className={`w-5 h-5 ${card.color}`} />
            </div>
          </div>
          <p className="text-2xl font-bold text-white">{card.value.toLocaleString()}</p>
          <p className="text-sm text-white/60">{card.label}</p>
        </div>
      ))}
    </div>
  );
};

export default EmailStatsCards;
